module.exports = __webpack_public_path__ + "img/0040.50ca34f9.png";